var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_7229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.125 8.74996L0.875046 8.74996C0.392027 8.74996 6.85448e-05 8.35793 6.85026e-05 7.87498C6.84604e-05 7.39196 0.392099 7 0.875045 7L27.125 7C27.608 7 28 7.39203 28 7.87498C28 8.35792 27.608 8.74995 27.125 8.74996Z",
    fill: "#383A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.875045 14.0474L27.125 14.0474C27.608 14.0474 28 14.4394 28 14.9223C28 15.4053 27.608 15.7973 27.125 15.7973L0.875046 15.7973C0.392027 15.7973 6.85448e-05 15.4053 6.85026e-05 14.9223C6.84604e-05 14.4394 0.392027 14.0474 0.875045 14.0474Z",
    fill: "#383A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.875039 21.0947L18.375 21.0947C18.858 21.0947 19.25 21.4868 19.25 21.9697C19.25 22.4527 18.858 22.8447 18.375 22.8447L0.875039 22.8447C0.392021 22.8447 6.23013e-05 22.4527 6.2259e-05 21.9697C-1.02624e-05 21.4867 0.39202 21.0947 0.875039 21.0947Z",
    fill: "#383A3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_7229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 28 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5cbbb7585bf35dd36b8770d5de0cfa9f.svg";
export { ForwardRef as ReactComponent };